.on_off {
  cursor: pointer;
}
.slider {
  width: 10em;
}
